import React, { useCallback, useState } from 'react';
import ThumbnailGrid from './ThumbnailGrid';
import ImageViewer from './ImageViewer';
import type { ImageGalleryProps } from './types';
import './style.scss';

const ImageGallery: React.FC<ImageGalleryProps> = ({
  images,
  className = '',
}) => {
  const [viewerIndex, setViewerIndex] = useState<number | null>(null);

  const handleImageClick = useCallback((index: number) => {
    setViewerIndex(index);
  }, []);

  const handleCloseViewer = useCallback(() => {
    setViewerIndex(null);
  }, []);

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div className={`dbo-image-gallery ${className}`}>
      <ThumbnailGrid images={images} onImageClick={handleImageClick} />
      {viewerIndex !== null && (
        <ImageViewer
          images={images}
          currentIndex={viewerIndex}
          onIndexChange={handleImageClick}
          onClose={handleCloseViewer}
        />
      )}
    </div>
  );
};

export default ImageGallery;
